<template>
  <div>
    <loader :loader="sending" />
    <div class="container">
      <validation-observer ref="form">
        <v-form @submit.prevent="obtainImage(1)">
          <v-row v-if="model && model.idPatient">
            <v-col cols="12" md="12" sm="12">
              <patient-information :model="model" />
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <Patient-consultation-info :model="model" />
            </v-col>
          </v-row>
          <br />
          <v-row class="mt-2 mb-2">
            <v-expansion-panels v-model="panelSV">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3>Somatometría</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col cols="12" md="12" sm="12">
                    <patient-somatometry
                      :model="modelSomatometry"
                      :suimFlag="suimFlag"
                    />
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-divider></v-divider>
            <div class="separator20-50"></div>
          </v-row>
          <div id="container">
            <v-col>
              <h3 class="font-weight-black mb-5">Odontograma</h3>
            </v-col>
            <v-col md="12">
              <v-col ref="photo" v-if="!isViewDetailsForm">
                <Odontograma
                  ref="Odontograma"
                  :treatment="treatment"
                  @OpenDialog="OpenDialog"
                  :dentalTreatment="dentalTreatment"
                  :searchTreatmentsByTooth="searchTreatmentsByTooth"
                />
              </v-col>
              <v-col ref="photo" v-if="isViewDetailsForm">
                <v-img
                  :src="model.odontogramaImage"
                  :lazy-src="model.odontogramaImage"
                  class="grey lighten-2"
                />
              </v-col>
              <template>
                <OdontogramaTable
                  ref="OdontogramaTable"
                  :arr="listDentalTreatments"
                  :deleteTreatment="deleteTreatment"
                />
              </template>
            </v-col>
          </div>
          <template>
            <v-col>
              <h3 class="font-weight-black mb-5">Revisión de prótesis</h3>
            </v-col>
            <v-col align="center">
              <v-btn
                :disabled="isViewDetailsForm"
                v-on:click="protesischeck = !protesischeck"
                class="align-center"
                :color="protesischeck ? 'primary' : '#EF5350'"
              >
                <p class="white--text">Revisión de prótesis</p>

                <v-icon right color="white">
                  {{ protesischeck ? "mdi-check" : "mdi-close" }}</v-icon
                >
              </v-btn>
            </v-col>
          </template>
          <template>
            <v-row justify="space-around">
              <v-col cols="auto">
                <v-dialog v-model="dialog" max-width="850" persistent>
                  <v-card>
                    <v-toolbar color="primary" dark>
                      <h3 class="pr-4">Procedimientos</h3>
                      <div class="subtitle-1">
                        Diente:&nbsp;
                        <span
                          class="font-weight-bold text-decoration-underline"
                        >
                          {{ dentalTreatment.mapId }}</span
                        >
                        Zona:&nbsp;
                        <span
                          class="font-weight-bold text-decoration-underline"
                        >
                          {{ dentalTreatment.zoneName }}</span
                        >
                      </div>
                    </v-toolbar>
                    <v-card-text>
                      <v-row justify="center">
                        <v-col
                          cols="4"
                          v-for="(process, index) in treatment"
                          :key="index"
                        >
                          <v-checkbox
                            v-model="selectTreatments"
                            :label="process.text"
                            :color="process.color"
                            :value="process"
                            required
                            @change="selectTreatmentsFuction($event)"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn plain color="error" @click="cancelPicks()">
                        Cancelar <v-icon right>mdi-close</v-icon>
                      </v-btn>
                      <v-btn text @click="saveTreatments()">Aceptar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
          <v-col cols="12" md="12" sm="12" class="mb-5">
            <h3 align="left">Nota médica:</h3>
            <br />
            <v-row class="mb-5">
              <v-col
                @click.right.prevent
                @copy.prevent
                @paste.prevent
                ondrop="return false;"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Nota médica"
                  rules="required"
                >
                  <vue-editor
                    v-model="model.content"
                    :errors-message="errors"
                    required
                    :disabled="isViewDetailsForm"
                    @input="onEditorInput"
                  />
                  <span class="error--text">{{ errors.toString() }}</span>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <PatientCIE10Component
                v-if="this.model.diagnosticDetail != null"
                :model="model"
                :isViewDetailsForm="isViewDetailsForm"
                :saveCie10Changes="saveCie10Changes"
                :isUpdate="true"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-btn
                color="primary"
                rounded
                dense
                @click="displayPrescription = true"
                :disabled="
                  isViewDetailsForm ||
                  this.statusDispense == $cnst.STATUS_PRESCRIPTION_DISPENSED ||
                  this.statusDispense == $cnst.STATUS_PRESCRIPTION_CANCELLED
                "
              >
                Receta médica<v-icon right>mdi-pill</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <div name="prescription" v-if="displayPrescription">
            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-2">Receta</h3>
              </v-col>
              <v-col class="text-right" v-if="displayPrescription">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      icon
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      @click="displayPrescription = false"
                    >
                      <v-icon size="30px">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <validation-observer
              v-slot="{ invalid }"
              ref="formPrescription"
              disabled
            >
              <v-form
                lazy-validation
                v-model="formPrescriptionValid"
                class="mt-8 mb-8"
                @submit.prevent="obtainImage(1)"
              >
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors, valid }"
                      name="Producto"
                      rules="required"
                    >
                      <v-autocomplete
                        dense
                        clearable
                        required
                        auto-select-first
                        autocomplete="off"
                        :error-messages="errors"
                        :items="products"
                        return-object
                        :item-text="products.text"
                        :item-value="products.value"
                        v-model.trim="prescriptionProduct.product"
                        label="Producto*"
                        clear-icon="mdi-eraser"
                        no-data-text="Sin resultados disponibles."
                      >
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                          {{ valid ? " mdi-check" : "" }}
                        </v-icon>
                      </v-autocomplete>
                      <small v-if="prescriptionProduct.product">
                        Cantidad en stock :{{
                          prescriptionProduct.product.quantityInStock
                        }}
                      </small>
                    </validation-provider>
                  </v-col>

                  <v-col>
                    <validation-provider
                      v-slot="{ errors, valid }"
                      name="Cantidad"
                      :rules="rulesQuantityProduct"
                    >
                      <v-text-field
                        dense
                        clearable
                        required
                        autocomplete="off"
                        :error-messages="errors"
                        :disabled="!prescriptionProduct.product"
                        @change="setNumber(prescriptionProduct.quantity)"
                        v-model="prescriptionProduct.quantity"
                        label="Cantidad*"
                        clear-icon="mdi-eraser"
                      >
                        <v-icon
                          slot="append"
                          :color="
                            valid && prescriptionProduct.quantity
                              ? 'success'
                              : ''
                          "
                        >
                          {{
                            valid && prescriptionProduct.quantity
                              ? " mdi-check"
                              : ""
                          }}
                        </v-icon>
                      </v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col>
                    <validation-provider
                      v-slot="{ errors, valid }"
                      name="Instrucciones"
                      rules="required|max:1000"
                    >
                      <v-text-field
                        :counter="1000"
                        maxlength="1000"
                        v-model.trim="prescriptionProduct.instructions"
                        label="Instrucciones*"
                        clearable
                        required
                        dense
                        autocomplete="off"
                        :error-messages="errors"
                        clear-icon="mdi-eraser"
                      >
                        <v-icon
                          slot="append"
                          :color="
                            valid && prescriptionProduct.instructions
                              ? 'success'
                              : ''
                          "
                        >
                          {{
                            valid && prescriptionProduct.instructions
                              ? " mdi-check"
                              : ""
                          }}
                        </v-icon>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row align="center" justify="space-around" class="mb-5 mt-4">
                  <v-btn
                    color="secondary"
                    text
                    @click="resetPrescriptionForm()"
                    type="button"
                    dense
                    outlined
                    small
                    >Limpiar
                    <v-icon right>mdi-eraser</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="addPrescriptionProduct()"
                    type="button"
                    :disabled="invalid"
                    dense
                    small
                  >
                    Agregar <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
              </v-form>
            </validation-observer>
            <!-- <v-row>
              <v-col>
                <v-data-table
                  :headers="headersPrescription"
                  :items="prescriptionProducts"
                  :footer-props="{
                    'items-per-page-text': 'Elementos por página',
                    'items-per-page-all-text': 'Todo',
                  }"
                  no-results-text="Sin resultados coincidentes con el búsqueda"
                  loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles"
                  class="mx-5"
                  dense
                  fixed-header
                  height="auto"
                >
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="removeProduct(index)">
                          <v-icon color="error" v-bind="attrs" v-on="on">
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Remover {{ item.product.productKey }} </span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row> -->
          </div>
          <v-card v-if="prescriptionProducts.length > 0">
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headersPrescription"
                  :items="prescriptionProducts"
                  :footer-props="{
                    'items-per-page-text': 'Elementos por página',
                    'items-per-page-all-text': 'Todo',
                  }"
                  no-results-text="Sin resultados coincidentes con el búsqueda"
                  loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles"
                  class="mx-5"
                  dense
                  fixed-header
                  height="auto"
                >
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon x-small
                          @click="removeProduct(index)"
                          :disabled="
                            statusDispense ==
                              $cnst.STATUS_PRESCRIPTION_DISPENSED ||
                            statusDispense ==
                              $cnst.STATUS_PRESCRIPTION_CANCELLED
                              
                          "
                        >
                          <v-icon color="error" v-bind="attrs" v-on="on">
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Remover {{ item.product.productKey }} </span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientSomatometry from "@/app/components/common/patient/PatientSomatometry.vue";
import PatientCIE10Component from "@/app/components/common/patient/PatientCIE10Component.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import {
  ProductsRequest,
  ProcedureRequest,
  VitalSignRequest,
  ProcedureApplicationRequest,
} from "@/core/request/";
import Odontograma from "@/app/components/base/odontograma/Odontograma.vue";
import OdontogramaTable from "@/app/components/base/odontograma/OdontogramaTable.vue";
import odontogramaFull from "@/json/odontograma_full.json";
// import DentalAppointmentModalConfirm from "@/app/components/dental/pending/DentalAppointmentModalConfirm.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";
import Loader from "@/app/components/base/loader/Loader.vue";

export default {
  name: "ExternalConsultationForm",
  props: {
    model: Object,
    modalPDF: false,
    isViewDetailsForm: Boolean,
    takePictureOdontograma: Boolean,
    saveCie10Changes: Boolean,
  },
  components: {
    PatientInformation,
    PatientSomatometry,
    PatientCIE10Component,
    PatientConsultationInfo,
    VueEditor,
    Odontograma: Odontograma,
    OdontogramaTable: OdontogramaTable,
    // DentalAppointmentModalConfirm,
    ValidationObserver,
    ValidationProvider,
    Loader,
  },
  data() {
    return {
      /*************************** ODONTOGRAMA DATA *****************************************/
      odontograma: [],
      treatment: [],
      dialog: false,
      dentalTreatment: {
        id: "",
        mapId: "",
        zone: "",
        zoneName: "",
        area: "",
        selectTreatments: [],
      },
      listDentalTreatments: [],
      selectTreatments: [],
      arr: [],
      protesischeck: false,
      odontogramImage: "",
      /*****************************ODONTOGRAMA DATA END********************************* */
      displayPrescription: false,
      formPrescriptionValid: true,
      formSpecialityValid: true,
      products: [],
      prescriptionProduct: {},
      prescriptionProducts: [],
      headersPrescription: [
        {
          text: "Clave del producto",
          value: "product.product_key",
          align: "center",
          sortable: false,
        },
        {
          text: "Producto",
          value: "product.name",
          align: "center",
          sortable: false,
        },
        {
          text: "Cantidad",
          value: "quantity",
          align: "center",
          sortable: false,
        },
        {
          text: "Instrucciones",
          value: "instructions",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
      specialities: [],
      modalities: [],
      studyProfiles: [],
      orderStudy: {},
      orderStudies: [],
      odontogramaData: {},
      statusDispense: 0,
      /*************COMPONENTS*****************/
      panelSV: 0,
      suimFlag: 1,
      modelSomatometry: {
        inputsVitalSigns: [],
        vitalSigns: [],
      },
      sending: false,
    };
  },
  watch: {
    dialog: function () {
      if (!this.dialog) {
        let i = setTimeout(this.obtainOdontogramaImage(), 2000);
      }
    },
    protesischeck: function () {
      if (this.protesischeck) {
        let protesischeckfill = [5];
        this.model.procedureApplicationListGeneral = protesischeckfill;
      } else if (!this.protesischeck) {
        this.model.procedureApplicationListGeneral = [];

        // ELIMINA REVISION DE PROTESIS idProcedure: [5]
        let filteredData = this.model.listDentalTreatments.filter(item => 
          !item.listProcedure.some(procedure => procedure.idProcedure.includes(5))
        );
        this.model.listDentalTreatments = filteredData;
      }
    },
    // model: function() {
    //   this.model = this.odontogramaData;
    // },
    takePictureOdontograma: function () {
      if (this.takePictureOdontograma == true) {
        this.obtainOdontogramaImage();
      }
    },
  },

  computed: {
    rulesQuantityProduct() {
      let quantity = 0;
      if (this.$utilFront.nonEmpty(this.prescriptionProduct.product)) {
        quantity = this.prescriptionProduct?.product?.quantityInStock;
      }
      return `required|numeric|min_value:1|max_value:${quantity}`;
    },
  },
  created() {
    this.model.procedureApplicationListGeneral = [];
    this.model.products = [];
    let idBranchOffice = this.$utilFront.getIdBranchOffice();
    ProductsRequest.listAllProductsWiExistence({
      idBranchOffice: idBranchOffice,
    }).then((response) => {
      let { code, data } = response.data;
      if (code == 200) {
        this.products = data.map((product) => {
          const description = `${product.name}, ${product.text}`;
          return {
            text:
              product.product_key + " - " + product.name + " " + product.text,
            value: product.idProduct,
            idProduct: product.idProduct,
            disabled: false,
            description: product.text,
            name: description,
            quantityInStock: product.quantityInStock,
            product_key: product.product_key,
            request: 0,
            instruction: "",
            productName: product.name,
          };
        });
      } else if (code == 401) {
        this.unauthorized();
      }
    });
    // .finally(() => {
    //   let finderProduct = (product) =>
    //     product.idProduct === this.prescriptionProducts.product.idProduct;
    //   let index = this.products.findIndex(finderProduct);
    //   this.products.splice(index, 1);
    // });
    this.getProcedures();
  },
  async mounted() {
    let idPatient = this.model.idPatient;
    let idMedicalPractice = this.model.idMedicalPractice;
    this.getVitalSignByPatient(idPatient, idMedicalPractice);
    await this.getOdontogramaData();
    await this.obtainOdontogramaImage();
  },
  methods: {
    setNumber(input) {
      this.prescriptionProduct.quantity = parseInt(input);
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.model.content = ''
      } else {
        this.model.content = html
      }
    },
    getVitalSignByPatient(idPatient, idMedicalPractice) {
      const params = {
        idPatient: idPatient,
        idMedicalPractice: idMedicalPractice,
      };
      VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice(params)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.modelSomatometry.inputsVitalSigns = res.data.data.map(
              (vital) => {
                let type = "";
                if (vital.vitalSignType.type === 1) {
                  type = "number";
                } else if (vital.vitalSignType.type === 2) {
                  type = "text";
                }
                let required = 0;
                if (vital.vitalSignType.required === 1) {
                  required = true;
                } else if (vital.vitalSignType.required === 2) {
                  required = false;
                }

                return {
                  idVitalSignType: vital.vitalSignType.idVitalSignType,
                  type: type,
                  label: vital.vitalSignType.name,
                  suffix: vital.vitalSignType.suffix,
                  status: vital.vitalSignType.status,
                  required: required,
                  value: vital.description,
                  idVitalSigns: vital.idVitalSigns,
                };
              }
            );
            this.modelSomatometry.vitalSigns = res.data.data.map((values) => {
              return {
                description: values.description,
                idVitalSigns: values.idVitalSigns,
                idVitalSignType: values.vitalSignType,
                typeName: values.vitalSignType.name,
                suffix: values.vitalSignType.suffix,
              };
            });
          } else if (
            res.data.code === 400 &&
            res.data.status === "BAD_REQUEST"
          ) {
            this.getTypeVitalSign();
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {});
    },
    async getOdontogramaData() {
      this.sending = true;
      let data = { idMedicalPractice: this.model.idMedicalPractice };
      this.odontograma = [];
      await ProcedureApplicationRequest.listAllByMedical(data)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.odontogramaData = res.data.data;
            this.statusDispense = this.odontogramaData?.prescription?.status;
            this.model.content = this.odontogramaData.diagnostic.textDiagnostic;
            this.model.diagnosticDetail =
              this.odontogramaData.diagnostic.diagnosticDetails;
            this.model.odontogramaImage = this.odontogramaData.odontogramaImage;
            this.model.cie10List = this.odontogramaData.cie10.map((i) => {
              return i.cie10.idCIE10;
            });
          }

          if (
            this.odontogramaData.prescription !== null &&
            this.odontogramaData.prescriptionProducts !== null
          ) {
            const products = this.odontogramaData.prescriptionProducts.map(
              (i) => {
                return {
                  product: {
                    name: i.products.fullName,
                    idProduct: i.products.idProduct,
                    // name: i.products.name,
                    product_key: i.products.product_key,
                    quantityInStock: i.products.quantityInStock,
                    text: i.products.text,
                    unit_masurement: i.products.unit_masurement,
                  } /**ITERAR PARA MAPEARLO CON EL PRODUCT_KEY :D */,
                  instructions: i.instruction,
                  quantity: i.request,
                };
              }
            );
            this.prescriptionProducts = products;
            let prodtu = [];
            for (const key in this.prescriptionProducts) {
              let obj = {
                request: this.prescriptionProducts[key].quantity,
                product: {
                  idProduct: this.prescriptionProducts[key].product.idProduct,
                },
                instructions: this.prescriptionProducts[key].instructions,
              };
              prodtu.push(obj);
            }
            this.model.products = prodtu;
          }
          if ( this.odontogramaData.procedureApplicationGeneral.find((element) => element == 5)) {
            this.protesischeck = true;
          }
        })
        .finally(() => {
          this.sending = false;
          this.fillOdontogramaData();
          // this.eraseProductsfromList();
        });
    },
    eraseProductsfromList() {
      // for (let n in this.prescriptionProducts) {
      // let finderProduct = (product) =>
      //    product.idProduct === this.prescriptionProducts.product.idProduct;
      //  let index = this.products.findIndex(finderProduct);
      //  this.products.splice(index, 1);
      // }
    },
    fillOdontogramaData() {
      let dentalData = this.odontogramaData.procedureApplication;
      for (const i in odontogramaFull) {
        for (const j in dentalData) {
          if (
            odontogramaFull[i]["@id"] == dentalData[j].tooth &&
            odontogramaFull[i]["@zone"] == dentalData[j].zone
          ) {
            let diente = {
              mapId: odontogramaFull[i]["@id"],
              id: odontogramaFull[i]["@d"],
              zone: odontogramaFull[i]["@zone"],
              zoneName: odontogramaFull[i]["@zoneName"],
              area: odontogramaFull[i]["@area"],
              selectTreatments: dentalData[j].procedures.map((proc) => {
                return {
                  text: proc.nameProcedure,
                  value: proc.idProcedure,
                  color: "#000000",
                };
              }),
            };
            let flag = "editar";
            if(this.$refs && this.$refs.Odontograma){
              this.$refs.Odontograma.paintSelectSVG(flag, diente);
            }
            this.listDentalTreatments.push(diente);
          }
          this.fillModelTreatments();
        }
      }
      // this.odontograma.push(dentalprocedures);
    },
    /******************************************* ODONTOGRAMA METHODS *************************************/
    selectTreatmentsFuction(element) {
      let validate = false;
      let hadit = false;
      let a = [];
      const fill = this.treatment.filter(function (x) {
        if (x.value == 18) {
          return x;
        } else if (x.value == 17) {
          return x;
        }
      });
      for (let g in element) {
        if (element[g].value == 15 || element[g].value == 14) {
          validate = true;
          hadit = true;
        }
        if (validate) {
          a = this.selectTreatments.concat(fill);
          this.selectTreatments = a;
          break;
        }
        if (hadit) {
          for (let s in this.selectTreatments)
            if (this.selectTreatments[s].value == 18) {
              this.selectTreatments.splice(s, 1);
              hadit = false;
            }
          for (let s in this.selectTreatments)
            if (this.selectTreatments[s].value == 17) {
              this.selectTreatments.splice(s, 1);
              hadit = false;
            }
          return this.selectTreatments;
        }
      }
    },
    getProcedures() {
      ProcedureRequest.listAllProceduresByType({
        idAttentionType: 2,
      })
        .then((res) => {
          let arreglo = [];
          this.treatment = res.data.data.map((process) => {
            if (
              process.attentionType === this.$cnst.CURE_CARE ||
              process.name === this.$cnst.SEALING_PITS_CRACKS
            ) {
              let obj = {
                text: process.name,
                value: process.idProcedure,
                color: process.color,
              };
              arreglo.push(obj);
            }
          });
          this.treatment = arreglo;
        })
        .finally(() => {});
    },
    saveTreatments() {
      const dataArr = new Set(this.selectTreatments);
      let result = [...dataArr];
      this.selectTreatments = result;
      if (this.selectTreatments.length > 0) {
        if (this.listDentalTreatments.length > 0) {
          let validation = true;
          for (let z in this.listDentalTreatments) {
            if (this.dentalTreatment.id == this.listDentalTreatments[z].id) {
              this.dialog = false;
              this.listDentalTreatments[z].selectTreatments =
                this.selectTreatments;
              validation = false;
              return (this.selectTreatments = []);
            }
          }
          this.fillModelTreatments();
          if (validation) {
            this.dentalTreatment.selectTreatments = this.selectTreatments;
            this.listDentalTreatments.unshift(this.dentalTreatment);
            // this.reverseOrder();
            this.searchTreatmentsByTooth();
            this.fillModelTreatments();
            this.selectTreatments = [];
            this.dialog = false;
            return (this.selectTreatments = []);
          }
        } else {
          this.dentalTreatment.selectTreatments = this.selectTreatments;
          this.listDentalTreatments.unshift(this.dentalTreatment);
          // this.reverseOrder();
          this.searchTreatmentsByTooth();
          this.fillModelTreatments();
          this.selectTreatments = [];
          this.dialog = false;
        }
      }
      this.fillModelTreatments();
      this.obtainOdontogramaImage();
    },
    fillModelTreatments() {
      let procedures = [];
      for (let k in this.listDentalTreatments) {
        if (
          this.listDentalTreatments[k].mapId ===
          this.listDentalTreatments[k].mapId
        ) {
          let obj = {
            tooth: this.listDentalTreatments[k].mapId,
            listProcedure: [
              {
                idProcedure: this.listDentalTreatments[k].selectTreatments.map(
                  (val) => {
                    return val.value;
                  }
                ),
                zone: this.listDentalTreatments[k].zone,
              },
            ],
          };
          procedures.push(obj);
        }
      }
      this.model.listDentalTreatments = procedures;
    },
    reverseOrder() {
      this.listDentalTreatments = this.listDentalTreatments.reverse();
    },
    OpenDialog(e) {
      this.dentalTreatment = { ...e };
      this.dialog = true;
      if (this.dialog == true || this.listDentalTreatments.length > 0) {
        for (const c in this.listDentalTreatments) {
          if (this.dentalTreatment.id == this.listDentalTreatments[c].id) {
            return (this.selectTreatments =
              this.listDentalTreatments[c].selectTreatments);
          }
        }
      }
    },
    searchTreatmentsByTooth() {
      for (const i in odontogramaFull) {
        for (const j in this.listDentalTreatments) {
          if (
            odontogramaFull[i]["@id"] == this.listDentalTreatments[j].mapId &&
            odontogramaFull[i]["@zone"] == this.listDentalTreatments[j].zone
          ) {
            const value = this.dentalTreatment.selectTreatments.length;
            if(this.$refs && this.$refs.Odontograma){
              this.$refs.Odontograma.paintSelectSVG(value);
            }
          }
        }
      }
    },
    deleteTreatment(index) {
      const value = 0;
      if(this.$refs && this.$refs.Odontograma){
        this.$refs.Odontograma.paintSelectSVG(
        value,
        this.listDentalTreatments[index]
      );
      }
      
      this.listDentalTreatments.splice(index, 1);
      this.fillModelTreatments();
      this.obtainOdontogramaImage();
    },
    cancelPicks() {
      this.dialog = false;
      this.selectTreatments = [];
    },
    getDate(date) {
      this.model.startTime = date;
    },
    async obtainOdontogramaImage() {
      this.sending = true;
      var domtoimage = require("dom-to-image");
      const node = this.$refs.photo;
      await domtoimage.toPng(node).then((dataUrl) => {
        var img = new Image();
        img.src = dataUrl;
        this.odontogramImage = img.src;
        this.model.odontogramImage = this.odontogramImage;
        this.sending = false;
      });
      this.fillModelTreatments();
    },
    /******************************************************************************************************************************** */
    resetPrescriptionForm() {
      this.prescriptionProduct = {};
      this.$refs.formPrescription.reset();
    },
    addPrescriptionProduct() {
      let flag = false;
      for (let p in this.prescriptionProducts) {
        if (
          this.prescriptionProducts[p].product.idProduct ==
          this.prescriptionProduct.product.idProduct
        ) {
          flag = true;
          this.$utilFront.notifications(
            "Producto ya agregado en la receta",
            "ERROR"
          );
        }
      }
      if (!flag) {
        if (this.$refs.formPrescription.validate()) {
          //Agregar a los productos
          // if (this.$utilFront.isEmptyList(this.prescriptionProducts)) {
          //   this.prescriptionProducts = [];
          // }
          this.prescriptionProducts.push(this.prescriptionProduct);
          //Remover de los productos
          let finderProduct = (product) =>
            product.idProduct === this.prescriptionProduct.product.idProduct;
          let index = this.products.findIndex(finderProduct);
          this.products.splice(index, 1);
          //Limpiar formulario

          this.resetPrescriptionForm();
        }
      }
      let products = [];
      for (const key in this.prescriptionProducts) {
        let obj = {
          request: this.prescriptionProducts[key].quantity,
          product: {
            idProduct: this.prescriptionProducts[key].product.idProduct,
          },
          instructions: this.prescriptionProducts[key].instructions,
        };
        products.push(obj);
      }
      this.model.products = products;
    },
    removeProduct(index) {
      let product = {
        text:
          this.prescriptionProducts[index].product.product_key +
          " - " +
          this.prescriptionProducts[index].product.name +
          " " +
          this.prescriptionProducts[index].product.text,
        idProduct: this.prescriptionProducts[index].product.idProduct,
        name: this.prescriptionProducts[index].product.name,
        quantityInStock:
          this.prescriptionProducts[index].product.quantityInStock,
        product_key: this.prescriptionProducts[index].product.product_key,
      };
      this.products.unshift(product);
      this.prescriptionProducts.splice(index, 1);
      let products = [];
      for (const key in this.prescriptionProducts) {
        let obj = {
          request: this.prescriptionProducts[key].quantity,
          product: {
            idProduct: this.prescriptionProducts[key].product.idProduct,
          },
          instructions: this.prescriptionProducts[key].instructions,
        };
        products.push(obj);
      }
      this.model.products = products;
    },
  },
};
</script>
